import API from '../index';
import { Coupon } from '../../types/payment';

const addCoupon = async (couponCode: string): Promise<Coupon> => {
  const data: Coupon = await API.post('/customer/add-coupon', { code: couponCode });
  return data;
};

export default addCoupon;
